import { applyMiddleware, createStore, Middleware, Store } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
// import logger from 'redux-logger'
import {
  PersistConfig,
  Persistor,
  persistReducer,
  persistStore
} from 'redux-persist'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import thunk from 'redux-thunk'
import rootReducer from '../store'

const persistConfig: PersistConfig = {
  key: 'root',
  storage,
  blacklist: ['form', 'auth_user'],
  stateReconciler: autoMergeLevel2
}

export default function configureStore(
  onCompletion?: () => void
): {
  store: Store
  persistor: Persistor
} {
  const middleware: Middleware[] = [thunk]
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // middleware.push(logger)
  }

  const pReducer = persistReducer(persistConfig, rootReducer)
  const store = createStore(
    pReducer,
    composeWithDevTools(applyMiddleware(...middleware))
  )
  const persistor = persistStore(store, undefined, onCompletion)
  return { store, persistor }
}



// WEBPACK FOOTER //
// ./src/boot/store.ts